import QueueMonitor from '@/components/QueueMonitor';

export default function QueueMonitorPage() {
  return (
    <div className="p-6 space-y-6">
      <QueueMonitor />
    </div>
  );
}
